/**
 * Hub attention items from Real Estate staff summary.
 */
export function buildHubRealEstateAttentionFromSummary(summary = {}) {
  const items = [];
  const inspectionsToSchedule = summary.inspectionsToSchedule ?? 0;
  const inspectionScheduled = summary.inspectionScheduled ?? 0;
  const awaitingContact = summary.awaitingContact ?? summary.byStatus?.awaiting_contact ?? 0;
  const submitted = summary.submitted ?? summary.byStatus?.submitted ?? 0;

  if (submitted > 0) {
    items.push({
      id: "re-submitted",
      count: submitted,
      title: "New property requests",
      description: "Submitted property interest requests need review.",
      cta: "View real-estate requests",
      path: "/super_admin/investor_portal/requests/real-estate",
      severity: "critical",
      badge: "Real estate",
      group: "Service requests",
    });
  }

  if (awaitingContact > 0) {
    items.push({
      id: "re-awaiting-contact",
      count: awaitingContact,
      title: "Property requests awaiting contact",
      description: "Follow up with customers on property inquiries.",
      cta: "View queue",
      path: "/super_admin/investor_portal/requests/real-estate",
      severity: "warning",
      badge: "Real estate",
      group: "Service requests",
    });
  }

  if (inspectionsToSchedule > 0) {
    items.push({
      id: "re-inspections-to-schedule",
      count: inspectionsToSchedule,
      title: "Property inspections to schedule",
      description: "Requests are ready for inspection scheduling.",
      cta: "View real-estate requests",
      path: "/super_admin/investor_portal/requests/real-estate",
      severity: "info",
      badge: "Inspection",
      group: "Service requests",
    });
  }

  if (inspectionScheduled > 0) {
    items.push({
      id: "re-inspection-scheduled",
      count: inspectionScheduled,
      title: "Upcoming property inspections",
      description: "Inspections are scheduled — complete or reschedule as needed.",
      cta: "View inspections",
      path: "/super_admin/investor_portal/requests/real-estate",
      severity: "info",
      badge: "Scheduled",
      group: "Service requests",
    });
  }

  return items;
}

/** @deprecated Prefer buildHubRealEstateAttentionFromSummary — coop service requests retired. */
export function buildInvestorOperationsAttention(companyId, getMetrics) {
  const m = typeof getMetrics === "function" ? getMetrics(companyId) : getMetrics || {};
  return buildHubRealEstateAttentionFromSummary({
    inspectionsToSchedule: m.inspectionsToSchedule,
    inspectionScheduled: m.inspectionScheduled,
    awaitingContact: m.cooperativeAwaitingContact ? 0 : m.awaitingContact,
    submitted: m.submitted,
  });
}

export function buildGroupedAttention(items = []) {
  const groups = ["Investments", "Marketplace", "Identity", "Service requests"];
  return groups
    .map((group) => ({
      group,
      items: items.filter((i) => i.group === group),
    }))
    .filter((g) => g.items.length > 0);
}
